var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SpanCard',{attrs:{"date-range":_vm.dateRange,"span":_vm.span,"fluid":"","show-toolbar":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }